import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MessageServiceService } from 'src/app/services/message-service.service';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent implements OnInit {

  @Output() popUpConfirmationEvent = new EventEmitter<boolean>();
  constructor(private messageService: MessageServiceService) { }

  ngOnInit() {
  }


  onConfirm() {
    this.popUpConfirmationEvent.emit(true);
    this.messageService.clear();
  }

  onReject() {
    this.popUpConfirmationEvent.emit(false);
    this.messageService.clear();
  }
}
